/*
 * @Descripttion: 
 * @Author: chenxt
 * @Date: 2023-11-20 16:22:03
 */
import router from './router'
import store from './store'
import {Toast} from 'vant'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {getToken} from '@/utils/auth' // get token from cookie
import { asyncRoutes } from "@/router";

NProgress.configure({showSpinner: false}) // NProgress Configuration

const whiteList = ['/loginOld','/auth-redirect','/login','/error', '/home', '/queryFile'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
    // start progress bar
    NProgress.start()

    // determine whether the user has logged in
    const hasToken = getToken()

    if (hasToken) {
        if(to.path == '/login' || to.path == '/loginOld' || to.path == '/home') {
            next()
        } else {
            const hasGetUserInfo = store.getters.name;
            if(hasGetUserInfo) {
                next()
            }else {
                try{
                    store.dispatch("getInfo").then(() => {
                        store.dispatch("getListTreeFuns").then(menusList => {
                            const data = menusList.data;
                            store
                            .dispatch("permissionFuns/generateRoutes", data)
                            .then(authRoutes => {
                                authRoutes.forEach(i=> {
                                    asyncRoutes.push(i)
                                })
                                const resultRouter = asyncRoutes
                                router.addRoutes(resultRouter);
                                next({ ...to, replace: true }); //
                            });
                        });
                    })
                } catch {
                    next(`/login`);
                    NProgress.done();
                }
            }
        }
    }else {
        if (whiteList.indexOf(to.path) !== -1) {
            // 没有token但是是白名单的路由（也包括登录），直接进入该路由
            next();
        } else {
            // 不是白名单又没有token的路由，转向登录
            document.title = "登录";
            // 暂时都可以跳转
            next("/loginOld");
            // next();
        }
    }
})

//   if (to.path === '/login') {
//     // if is logged in, redirect to the home page
//     next({ path: '/' })
//     NProgress.done()
//   } else {
//     // determine whether the user has obtained his permission roles through getInfo
//     const hasRoles = store.getters.roles && store.getters.roles.length > 0
//     if (hasRoles) {
//       next()
//     } else {
//       try {
//         // get user info
//         // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
//         const { roles } = await store.dispatch('user/getInfo')

//         // generate accessible routes map based on roles
//         const accessRoutes = await store.dispatch('permission/generateRoutes', roles)

//         // dynamically add accessible routes
//         router.addRoutes(accessRoutes)

//         // hack method to ensure that addRoutes is complete
//         // set the replace: true, so the navigation will not leave a history record
//         next({ ...to, replace: true })
//       } catch (error) {
//         // remove token and go to login page to re-login
//         await store.dispatch('user/resetToken')
//           Toast.error(error || 'Has Error')
//         next(`/login?redirect=${to.path}`)
//         NProgress.done()
//       }
//     }
//   }
// } else {
//   /* has no token*/
//   //没有拿到token暂时全部开放
//   // if (whiteList.indexOf(to.path) !== -1) {
//     // in the free login whitelist, go directly
//     next()
//   // } else {
//   //   // other pages that do not have permission to access are redirected to the login page.
//   //   next(`/login?redirect=${to.path}`)
//   //   NProgress.done()
//   // }
// }
// })

router.afterEach(() => {
    // finish progress bar
    NProgress.done()
})
